/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Rule {
  readonly id?: number;
  ref: string;
  sortKey?: number;
  operator: Rule.OperatorEnum;
  notFoundOk?: boolean;
  exactMatch?: boolean;
  govBody?: Rule.GovBodyEnum;
  region?: Rule.RegionEnum;
  propertyTypes?: Array<Rule.PropertyTypesEnum>;
  explanation?: string;
  explanationFr?: string;
  explanationNl?: string;
  folderModes?: Array<Rule.FolderModesEnum>;
  fetchRank?: number;
  popup?: boolean;
  popupText?: string;
  popupTextFr?: string;
  popupTextNl?: string;
  explanationPopup?: string;
  explanationPopupFr?: string;
  explanationPopupNl?: string;
  varLeftConfidenceThreshold?: number;
  varRightConfidenceThreshold?: number;
  matchRestrictedToSameEntity?: boolean;
  displayOperator?: Rule.DisplayOperatorEnum;
  varLeft: number;
  varRight?: number;
  constant?: number;
  triggerRule?: number;
  tags?: Array<number>;
}
export namespace Rule {
  export type OperatorEnum = 'GT' | 'LT' | 'EQ' | 'NE' | 'SIM' | 'GTE' | 'LTE' | 'IN' | 'NIN' | 'EXI' | 'NULL';
  export const OperatorEnum = {
    GT: 'GT' as OperatorEnum,
    LT: 'LT' as OperatorEnum,
    EQ: 'EQ' as OperatorEnum,
    NE: 'NE' as OperatorEnum,
    SIM: 'SIM' as OperatorEnum,
    GTE: 'GTE' as OperatorEnum,
    LTE: 'LTE' as OperatorEnum,
    IN: 'IN' as OperatorEnum,
    NIN: 'NIN' as OperatorEnum,
    EXI: 'EXI' as OperatorEnum,
    NULL: 'NULL' as OperatorEnum,
  };
  export type GovBodyEnum = 'FEDERAL' | 'REGIONAL';
  export const GovBodyEnum = {
    FEDERAL: 'FEDERAL' as GovBodyEnum,
    REGIONAL: 'REGIONAL' as GovBodyEnum,
  };
  export type RegionEnum = 'WALLONIE' | 'FLANDRES' | 'BXL';
  export const RegionEnum = {
    WALLONIE: 'WALLONIE' as RegionEnum,
    FLANDRES: 'FLANDRES' as RegionEnum,
    BXL: 'BXL' as RegionEnum,
  };
  export type PropertyTypesEnum = 'HOUSE' | 'HOUSE_AND_DEPEDENCIES' | 'APPARTMENT' | 'TERRAIN' | 'TERRAINS';
  export const PropertyTypesEnum = {
    HOUSE: 'HOUSE' as PropertyTypesEnum,
    HOUSEANDDEPEDENCIES: 'HOUSE_AND_DEPEDENCIES' as PropertyTypesEnum,
    APPARTMENT: 'APPARTMENT' as PropertyTypesEnum,
    TERRAIN: 'TERRAIN' as PropertyTypesEnum,
    TERRAINS: 'TERRAINS' as PropertyTypesEnum,
  };
  export type FolderModesEnum = 'COMPROMIS' | 'VENTE' | 'CREDIT' | 'MANDAT_HYPO' | 'MAIN_LEVEE';
  export const FolderModesEnum = {
    COMPROMIS: 'COMPROMIS' as FolderModesEnum,
    VENTE: 'VENTE' as FolderModesEnum,
    CREDIT: 'CREDIT' as FolderModesEnum,
    MANDATHYPO: 'MANDAT_HYPO' as FolderModesEnum,
    MAINLEVEE: 'MAIN_LEVEE' as FolderModesEnum,
  };
  export type DisplayOperatorEnum = 'GT' | 'LT' | 'EQ' | 'NE' | 'SIM' | 'GTE' | 'LTE' | 'IN' | 'NIN' | 'EXI' | 'NULL';
  export const DisplayOperatorEnum = {
    GT: 'GT' as DisplayOperatorEnum,
    LT: 'LT' as DisplayOperatorEnum,
    EQ: 'EQ' as DisplayOperatorEnum,
    NE: 'NE' as DisplayOperatorEnum,
    SIM: 'SIM' as DisplayOperatorEnum,
    GTE: 'GTE' as DisplayOperatorEnum,
    LTE: 'LTE' as DisplayOperatorEnum,
    IN: 'IN' as DisplayOperatorEnum,
    NIN: 'NIN' as DisplayOperatorEnum,
    EXI: 'EXI' as DisplayOperatorEnum,
    NULL: 'NULL' as DisplayOperatorEnum,
  };
}
